import React from 'react';
import { TrendingUp, Instagram, Facebook, Twitter } from 'lucide-react';
export function Footer() {
  return <footer className="bg-black border-t border-white/10 pt-16 pb-8" data-id="element-62">
      <div className="container mx-auto px-6" data-id="element-63">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8 mb-12" data-id="element-64">
          <div className="flex items-center gap-2" data-id="element-65">
            <div className="w-8 h-8 rounded-lg bg-gold/10 flex items-center justify-center border border-gold/20" data-id="element-66">
              <TrendingUp className="text-gold w-5 h-5" data-id="element-67" />
            </div>
            <span className="font-heading font-bold text-xl tracking-tight text-white" data-id="element-68">
              Indicadores<span className="text-gold" data-id="element-69">VIP</span>
            </span>
          </div>

          <div className="flex items-center gap-4" data-id="element-70">
            <a href="https://instagram.com/indicadoresvip" target="_blank" rel="noopener noreferrer" aria-label="Síguenos en Instagram @indicadoresvip" className="group flex items-center gap-2 h-10 px-3 rounded-full bg-white/5 text-zinc-400 hover:text-gold hover:bg-white/10 transition-all" data-id="element-71">
              <Instagram className="w-5 h-5" data-id="element-72" />
              <span className="text-sm font-medium" data-id="element-73">@indicadoresvip</span>
            </a>
            <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-zinc-400 hover:text-gold hover:bg-white/10 transition-all" data-id="element-74">
              <Facebook className="w-5 h-5" data-id="element-75" />
            </a>
            {/* Using Twitter icon as placeholder for TikTok since lucide doesn't have tiktok by default, or we can just use text */}
            <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-zinc-400 hover:text-gold hover:bg-white/10 transition-all font-bold text-sm" data-id="element-76">
              TK
            </a>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-zinc-500 text-center md:text-left" data-id="element-77">
          <p className="max-w-2xl" data-id="element-78">
            <strong data-id="element-79">Disclaimer:</strong> El trading implica riesgos
            significativos y puede no ser adecuado para todos los inversores. El
            alto grado de apalancamiento puede trabajar tanto a su favor como en
            su contra. Este contenido es solo educativo y no constituye asesoría
            financiera.
          </p>
          <p className="shrink-0" data-id="element-80">
            &copy; {new Date().getFullYear()} IndicadoresVIP. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>;
}